import contracts from './contracts'
import { FarmConfig, QuoteToken } from './types'

const farms: FarmConfig[] = [
  {
    pid: 0,
    lpSymbol: 'DEF',
    lpAddresses: {
      97: '',
      56: '0xC35786C9D727FCa19f17Ba78FC02B512482F8003',
    },
    tokenSymbol: 'SYRUP',
    tokenAddresses: {
      97: '',
      56: '0xC35786C9D727FCa19f17Ba78FC02B512482F8003',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },

  {
    pid: 1,
    lpSymbol: 'DEF-BNB LP',
    lpAddresses: {
      97: '',
      56: '0xa6cb43384A85fec4Ffb0B42F0d42A41c83F0a0c9',   // lp address token-bnb
    },
    tokenSymbol: 'DEF',
    tokenAddresses: {
      97: '',
      56: '0xC35786C9D727FCa19f17Ba78FC02B512482F8003', // token address
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },

]

export default farms
